<template>
    <div class="component-container" id="edit-subscriber">
        <div class="component-wrapper">
            <div class="subscribe-detail-box">
                <table class="table-subscribe-detail subscribe-detail-1">
                    <tr>
                        <th>订阅器名称：</th>
                        <td>
                            <span class="input-wrap">
                                {{subscriberInfo.name}}
                                <input :class="{disabled:!editSubscribeTitle}"
                                       :disabled="!editSubscribeTitle"
                                       class="edit-input"
                                       v-model="subscriberInfo.name"

                                >
                            </span>
                            <span @click="editSubscribeTitle=!editSubscribeTitle" class="btn-confirm" v-show="editSubscribeTitle">确定</span>
<!--                            <i @click="editSubscribeTitle=!editSubscribeTitle" class="icon icon-edit" v-show="!editSubscribeTitle"></i>-->
                        </td>
                    </tr>
                    <tr>
                        <th>公告类型：</th>
                        <td>
                            <div class="item-wrap" v-if="subscriberInfo.announcementVO&&subscriberInfo.announcementVO.length">
                                <span :key="item.key" class="item" v-for="item in subscriberInfo.announcementVO">{{item.value}}</span>
                            </div>
                            <div class="item-wrap" v-else>
                                <span class="item">全部</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>采购方式：</th>
                        <td>
                            <div class="item-wrap" v-if="subscriberInfo.purchaseVO&&subscriberInfo.purchaseVO.length">
                                <span :key="item.key" class="item" v-for="item in subscriberInfo.purchaseVO">{{item.value}}</span>
                            </div>
                            <div class="item-wrap" v-else>
                                <span class="item">全部</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>关键词：</th>
                        <td>
                            <div class="item-wrap" v-if="subscriberInfo.keywordVO&&subscriberInfo.keywordVO.length">
                                <span :key="item.key" class="item" v-for="item in subscriberInfo.keywordVO">{{item.value}}</span>
                            </div>
                            <div class="item-wrap" v-else>
                                <span class="item">全国</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>地区：</th>
                        <td>
                            <div class="item-wrap" v-if="subscriberInfo.regionNameVO.length">
                                <span :key="item.key" class="item" v-for="item in subscriberInfo.regionNameVO">{{item.value}}</span>
                            </div>
                            <div class="item-wrap" v-else>
                                <span>全国</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>项目金额：</th>
                        <td v-if="subscriberInfo.minMoney&&subscriberInfo.maxMoney">
                            {{subscriberInfo.minMoney/1000000+'万元-'+subscriberInfo.maxMoney/1000000+'万元'}}
                        </td>
                        <td v-else-if="subscriberInfo.minMoney&&!subscriberInfo.maxMoney">
                            {{subscriberInfo.minMoney/1000000+'万元以上'}}
                        </td>
                        <td v-else-if="!subscriberInfo.minMoney&&subscriberInfo.maxMoney">
                            {{subscriberInfo.maxMoney/1000000+'万元以下'}}
                        </td>
                        <td v-else>
                            不限
                        </td>
                    </tr>
                </table>
                <hr>
                <table class="table-subscribe-detail subscribe-detail-1">
                    <tr>
                        <th>接收频率：</th>
                        <td v-if="subscriberInfo.pushMode==0">定时接收 {{subscriberInfo.pushHour+':00'}}</td>
                        <td v-else>即时接收</td>
                    </tr>
                    <tr>
                        <th>接收方式：</th>
                        <td>
                            <div class="item-wrap">
                                <span :key="item.id" class="item" v-for="item in subscriberInfo.modeVO">
                                    <i class="icon icon-checked"></i>
                                    <span v-if="item.modeValue">
                                        {{item.subscribeMode==0?'消息中心':item.subscribeMode==1?'电子邮件':'短信'}}
                                    </span>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr :key="item.id" v-for="item in subscriberInfo.modeVO">
                        <th v-if="item.subscribeMode==1">电子邮箱：</th>
                        <th v-else-if="item.subscribeMode==2">接收手机号：</th>
                        <td v-if="item.subscribeMode!=0">
                            {{item.modeValue?item.modeValue:'暂无'}}
                        </td>
                    </tr>
                    <tr>
                        <th>到期时间：</th>
                        <td>
                            <span>{{subscriberInfo.dueTime}}</span>
                            <button @click="showSubscriber" class="btn-renew">续费</button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "editSubscriber",
        data(){
            return {
                editSubscribeTitle:false
            }
        },
        props:{
            subscriberInfo:{
                type:Object
            }
        },
        mounted() {

        },
        watch:{
            subscriberInfo:{
                handler(val){
                    console.log(val)
                },
                deep:true
            },
        },
        methods:{
            showSubscriber(){
                this.$store.commit('changeSubscriberShow',true)
            }
        }
    }
</script>

<style lang="less" scoped>
.component-container{
    @moudle-bg-color:#ffffff;
    @line:1px solid #E9E9E9;
    .component-wrapper{
        .subscribe-detail-box{
            background-color: inherit;

            .table-subscribe-detail{
                line-height: 46px;
                .fz(16px);
                tr{
                    th{
                        .width(120px);
                        text-align: right;
                        .color(#7C7C7C);
                    }
                    td{
                        .color(#090909);
                        padding: 5px 20px;

                        .btn-renew{
                            color: @main-color;
                            margin-left: 10px;
                        }
                        .item-wrap{
                            margin-left: -28px;
                            i{
                                .size(14px,13px);
                                .bg('@{img-base-url}orderDetail_icon-checked.png');
                            }
                            span{
                                display: inline-block;
                                margin-left: 28px;
                                vertical-align: middle;
                            }
                        }
                        .input-wrap{
                            position: relative;
                            vertical-align: middle;
                            padding: 5px 10px;

                            input.edit-input{
                                .size();
                                position: absolute;
                                left: 0;
                                top: 0;
                                background-color: #ffffff;
                                .fz(16px);
                                .color(#090909);
                                border:1px solid @main-color;
                                .border-radius(5px);
                                outline: @main-color;
                                padding-left: 5px;

                                &.disabled{
                                    padding: 0;
                                    border:none;
                                    outline: none;
                                }
                            }
                        }
                        .btn-confirm{
                            padding: 4px 11px;
                            margin-left: 3px;
                            border: 1px solid @main-color;
                            .border-radius(4px);
                            vertical-align: middle;
                            color: @main-color;
                            cursor: pointer;
                        }
                        i.icon-edit{
                            .size(15px,15px);
                            .bg('@{img-base-url}orderDetail_icon-modify.png');
                            cursor: pointer;
                        }
                    }
                }
            }
            hr{
                border-color: #E9E9E9;
            }
            .pay-money{
                .color(#090909);
                .fz(18px);
                text-align: right;
                padding: 45px 20px;
            }
        }
    }
}
</style>